// src/components/StructuredData.tsx
import { Helmet } from 'react-helmet-async';

export const EducationalStructuredData = () => {
    const structuredData = {
        "@context": "https://schema.org",
        "@type": "EducationalOrganization",
        "name": "AutoQuiz AI",
        "description": "AI-powered medical education platform generating interactive quiz videos for medical exam preparation and board certification",
        "url": "https://autoquizai.com",
        "sameAs": [
            // Add your social media profiles when available
            // "https://twitter.com/autoquizai",
            // "https://www.facebook.com/autoquizai",
            // "https://www.linkedin.com/company/autoquizai"
        ],
        "offers": {
            "@type": "AggregateOffer",
            "priceCurrency": "USD",
            "lowPrice": "0",
            "highPrice": "29.99",
            "offerCount": "3"
        },
        "audience": {
            "@type": "EducationalAudience",
            "educationalRole": "medical student"
        }
    };

    return (
        <Helmet>
            <script type="application/ld+json">
                {JSON.stringify(structuredData)}
            </script>
        </Helmet>
    );
};

// For individual quiz topics
export const QuizStructuredData = ({ topic, subject }: { topic: string, subject: string }) => {
    const structuredData = {
        "@context": "https://schema.org",
        "@type": "VideoObject",
        "name": `${topic} - ${subject} Medical Quiz`,
        "description": `AI-generated medical quiz video covering ${topic} concepts in ${subject} for exam preparation`,
        "educationalLevel": "Professional",
        "learningResourceType": "Assessment",
        "audience": {
            "@type": "EducationalAudience",
            "educationalRole": "medical student"
        },
        "inLanguage": "en-US",
        "educationalUse": "assessment"
    };

    return (
        <Helmet>
            <script type="application/ld+json">
                {JSON.stringify(structuredData)}
            </script>
        </Helmet>
    );
};

interface VideoStructuredDataProps {
  name: string;
  description: string;
  thumbnailUrl?: string;
  contentUrl?: string;
  embedUrl?: string;
  uploadDate?: string;
  inLanguage?: string;
}

export const VideoStructuredData = ({
  name,
  description,
  thumbnailUrl,
  contentUrl,
  embedUrl,
  uploadDate,
  inLanguage = "en-US",
}: VideoStructuredDataProps) => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "VideoObject",
    name,
    description,
    ...(thumbnailUrl
      ? { thumbnailUrl: [thumbnailUrl] }
      : {}),
    ...(contentUrl
      ? { contentUrl }
      : {}),
    ...(embedUrl
      ? { embedUrl }
      : {}),
    ...(uploadDate
      ? { uploadDate }
      : {}),
    inLanguage,
    learningResourceType: "Assessment",
    educationalUse: "assessment",
    isFamilyFriendly: true,
    publisher: {
      "@type": "Organization",
      name: "AutoQuiz AI",
      url: "https://autoquizai.com",
    },
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};
